import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const CircleCheckSvg = () => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 20.3217C4.477 20.3217 0 15.8447 0 10.3217C0 4.79866 4.477 0.321655 10 0.321655C15.523 0.321655 20 4.79866 20 10.3217C20 15.8447 15.523 20.3217 10
       20.3217ZM9.003 14.3217L16.073 7.25066L14.659 5.83666L9.003 11.4937L6.174 8.66466L4.76 10.0787L9.003 14.3217Z"
      fill="#00A143"
    />
  </svg>
);

const CircleCheck = (props: IIconProps) => <Icon component={CircleCheckSvg} {...props} />;

export default CircleCheck;
